<!--
  message-box的使用说明
  1> 在main.js中引入 import RaiseMessage from '@/components/app/raise_box'
 Vue.$RaiseMessage = Vue.prototype.$RaiseMessage = RaiseMessage
  2> 在组件所需处直接调用 例如：
      alert弹框：          this.$RaiseMessage.alert(require('@/components/app/raise_box/imgs/adopt_b.png'), title,{callback:callback})
      关闭弹框：            this.$RaiseMessage.close()
  3>弹窗图片放在该组件的imgs文件夹里，调用的时候直接改文件名，即可，点击弹窗执行的代码，可直接在callback里做,title可直接传空字符传
  调用示例

  this.$RaiseMessage.alert(require('@/components/app/raise_box/imgs/adopt_b.png'), '', { callback: () => { console.log('22222') } })
-->

<template>
  <div class="msgbox-wrapper common-toast-wrapper"
       v-show="value"
        :style="restStyle.wrapper"
       @click.self="handleMaskClick">
    <transition name="fade">
      <div class="msgbox" :style="restStyle.img">
        <!-- 歌曲加载信息 -->
        <div v-if="progressConfig && imgLoaded" class="delay-order-song">
          <h3>{{ songItem.music_name }}</h3>
          <Progress :progressConfig="progressConfig" />
        </div>
        <!-- 结束 -->
        <div v-if="showTopAvatar" class="user-info">
          <div class="avatar"><img :src="userAvatar" alt="用户头像"></div>
          <p>会员专享</p>
        </div>
        <div v-if="title !== ''" class="msgbox-title">
          <div class="title">{{ title }}</div>
        </div>
        <div class="msgbox-content">
          <!-- 金主信息 -->
          <div v-if="goldMessage.headimgurl || goldMessage.nickname" class="gold-info">
            <!-- <div class="avatar"><img :src='goldMessage.headimgurl' /></div> -->
            <p>好友<span>「{{(goldMessage.nickname || '神秘人')| goldNameF}}」</span>送您VIP</p>
          </div>
          <!-- 结束 -->
          <div class="click-action" :style="restStyle.clickArea" @click.stop="handleAction">
            <img v-if="!isTwoBg" :src="message" @load="() => this.imgLoaded=true" />
            <img v-if="isTwoBg" :src="newData[0]" @load="() => this.imgLoaded=true" />
            <img v-if="isTwoBg" class="topBg" :src="newData[1]" @load="() => this.imgLoaded=true" />
            <!-- 取消、确认按钮 start-->
            <div v-if="showCancelConfirmBtns" class="btns-wrap" :style="cancelConfirmBtnStyle">
              <div class="btn" @click.stop="handleClick('leftBtn')"></div>
              <div class="btn" @click.stop="handleClick('rightBtn')"></div>
            </div>
            <div v-if="showBreathBtns" class="btns-wrap precise-btns-wrap" :style="cancelConfirmBtnStyle">
              <div class="btn precise-btn-cancel" :style="{
                backgroundImage: `url(${preciseBtnConfig.cancelBtnImg})`,
                width: preciseBtnConfig.cancelBtnWidth || '24vw',
                height: preciseBtnConfig.cancelBtnHeight || '10.93vw'
              }" @click.stop="handleClick('leftBtn')"></div>
              <div class="btn precise-btn-confirm" :class="{ breath: preciseBtnConfig.confirmBtnBreath }" :style="{
                backgroundImage: `url(${preciseBtnConfig.confirmBtnImg})`,
                width: preciseBtnConfig.confirmBtnWidth || '55.73vw',
                height: preciseBtnConfig.confirmBtnHeight || '10.93vw'
              }" @click.stop="handleClick('rightBtn')">
                <div v-if="showCursor" class="cursor">
                  <img src="https://qncweb.ktvsky.com/20250603/vadd/861d88981d833d71103cf0afc07e8113.png" alt="手指">
                </div>
                <div v-if="tabConfig" class="custom-tab" :style="{
                  backgroundColor: tabConfig.backgroundColor,
                  color: tabConfig.textColor,
                  right: tabConfig.position.right || '2.67vw',
                  top: tabConfig.position.top || '-5.33vw',
                  borderRadius: tabConfig.borderRadius || '0.53vw'
                }">
                  {{ tabConfig.text }}
                </div>
              </div>
            </div>
            <!-- 取消、确认按钮 end-->
            <img
              v-if="clickButtonConfig"
              class="clickButton animated"
              @click="handlerButtonClick()"
              :class="clickButtonConfig.animateName"
              :src="clickButtonConfig.img"
              :style="styleClickbtn"
            >
            <div class="handContainer"
            :class="handEffectConfig.animateName"
            :style="handEffectStyle"
            >
              <img
                v-if="handEffectConfig"
                :src="handEffectConfig.img"
              >
            </div>
            <!-- 滚动消息组件 -->
            <ScrollMessages :show="showScrollMessages" :custom-style="scrollMessagesStyle" />
            <div v-if="showTopText" class="top-text" :style="restStyle.text">
              <p>{{ showTopText }}</p>
            </div>
            <!-- 原有倒计时 -->
            <countdown
              v-if="countDownEndTime && !preciseCountDown"
              class="down_time"
              :left-time="countDownEndTime"
              :style="restStyle.countdown"
            >
              <template
                v-slot:before
              >
                <div class="countdown">
                  <span>00:</span>
                  <span>00:</span>
                  <span>00后过期</span>
                </div>
              </template>
              <template
                v-slot:process="countdownScope"
              >
                <div class="countdown">
                  <span>{{ countdownScope.timeObj.h }}:</span>
                  <span>{{ countdownScope.timeObj.m }}:</span>
                  <span>{{ countdownScope.timeObj.s }}后过期</span>
                </div>
              </template>
              <template
                v-slot:finish
              >
                <div class="countdown">
                  <span>00:</span>
                  <span>00:</span>
                  <span>00后过期</span>
                </div>
              </template>
            </countdown>

            <!-- 新增精确倒计时组件 -->
            <div
              v-if="preciseCountDown && !countdownFinished"
              class="precise_countdown"
              :style="restStyle.preciseCountdown"
            >
              <div class="precise-countdown-wrapper">
                <span class="precise-time-unit">{{ minutes | formatTimeWithZero }}</span>
                <span class="precise-time-separator">:</span>
                <span class="precise-time-unit">{{ seconds | formatTimeWithZero }}</span>
                <span class="precise-time-separator">:</span>
                <span class="precise-time-unit">{{ milliseconds | formatMsWithZero }}</span>
                <span class="precise-time-text">后恢复原价19.9</span>
              </div>
            </div>

            <!-- VIP开通PLUS会员弹窗 -->
            <div v-if="imgLoaded && vipInfo.pay_fee" class="plus-toast">
              <div class="title-wrapper">
                <p>开通PLUS{{vipInfo.isOneVip ? '' : '年'}}会员</p>
                <p>立享折扣</p>
              </div>
              <div class="price">{{vipInfo.pay_fee / 100}}元</div>
            </div>
            <!-- 结束 -->
            <p v-if="showAgreement || showTopAgreement || showToastBottomAgreement" class="agreement" :class="{
              'agreement-top': showTopAgreement,
              'agreement-bottom': showToastBottomAgreement
            }" @click.stop="handleClickAgreement">阅读并同意《会员服务协议》</p>
          </div>
          <div v-if="bottomCallback" class="back-home" @click.stop="bottomCallback"></div>
          <!-- 带取消确认按钮弹窗右上角x形关闭按钮 -->
          <div v-if="showCancelConfirmBtns&&!showClose" class="close-icon" @click="doClose" ></div>
          <!-- 弹窗下面圆形关闭按钮 -->
          <img v-if="isBottomClose" src="https://qncweb-back1.ktvsky.com/20240919/vadd/8646ddc13b6b33a7441103c6a7674710.png" :style="closeBtn" class="bottom-close" @click="doClose" />
          <!-- 弹窗默认关闭按钮 -->
          <img v-if="showClose && imgLoaded && !isBottomClose && !isTopClose" :src="closeImg" :style="closeBtn" class="close" @click="doClose" />
          <!-- 弹窗内部右上角关闭按钮 -->
          <img v-if="showInsideClose" :style="restStyle.InsideClose" :src="InsideCloseImg" @click.self="doClose">
          <span v-if="isOrder" class="ordersong" @click.self="handleorderSong"></span>
        </div>
      </div>
    </transition>
    <img v-if="isTopClose" src="../adsense/static/close.png" class="top-close" @click="doClose" />
  </div>
</template>
<script type="text/babel">
import Vue from 'vue';
import vueAwesomeCountdown from 'vue-awesome-countdown';
import Progress from '@/components/common/loading/progress'
import ScrollMessages from '../photo_toast_new/scroll-messages.vue';
import store from '@/store'

Vue.use(vueAwesomeCountdown);
const CONFIRM_TEXT = '确定';
const CANCEL_TEXT = '取消';
export default {
  props: {
    modal: {
      default: true,
    },
    inputType: {
      type: String,
      default: 'text',
    },
  },
  components: {
    Progress,
    ScrollMessages,
  },
  filters: {
    formatTimeWithZero(value) {
      return value < 10 ? `0${value}` : value;
    },
    formatMsWithZero(value) {
      // 确保显示两位毫秒数字(0-99)
      return value < 10 ? `0${value}` : value;
    }
  },
  methods: {
    handleMaskClick() {
      // 只有onlyBtnClose为true时禁止遮罩关闭
      if (this.onlyBtnClose) return
      this.doClose()
    },
    handleClick(type) {
     if (type === 'leftBtn') {
       this.doClose(type)
     } else {
       this.handleAction(type)
     }
    },
    doClose(type) {
      this.value = false;
      this.countDownEndTime = 0;
      this.stopPreciseCountdown();

      // 存储当前倒计时值，以便下次重新启动
      if (this.preciseCountDown) {
        this.savedPreciseCountDown = this.preciseCountDown;
      }

      store.commit('SET_ORDER_LIST', true)
      setTimeout(() => {
        if (this.modal && this.bodyOverflow !== 'hidden') {
          document.body.style.overflow = this.bodyOverflow;
          document.body.style.paddingRight = this.bodyPaddingRight;
        }
        this.bodyOverflow = null;
        this.bodyPaddingRight = null;
      }, 200);
      this.opened = false;
      this.handEffectConfig = ''
      if (this.showCancelConfirmBtns && type != 'leftBtn') return
      // eslint-disable-next-line
      this.closeCallback && this.closeCallback();
    },
    handleorderSong() {
      // eslint-disable-next-line
      this.orderSongCallback && this.orderSongCallback();
    },
    handlerButtonClick() {
      if (typeof this.clickButtonConfig.handlerButtonClick === 'function') {
        this.clickButtonConfig.handlerButtonClick()
      }
    },
    handleAction(action) {
      if (this.showCancelConfirmBtns && action != 'rightBtn') return
      this.countDownEndTime = 0;
      this.stopPreciseCountdown();
      if (this.$type === 'prompt' && action === 'confirm' && !this.validate()) {
        return;
      }
      const { callback } = this;
      store.commit('SET_ORDER_LIST', true)
      // 如果回调不是调用微信支付，就直接关掉弹窗
      // 如果存在buyVipPlus，这里不关闭，在weixin.js -> wxPay的success关掉弹窗
      if (!String(callback).includes('buyVipPlus') && !String(callback).includes('buySingleRights')) {
        this.value = false
      }
      callback(action);
    },
    validate() {
      if (this.$type === 'prompt') {
        const { inputPattern } = this;
        if (inputPattern && !inputPattern.test(this.inputValue || '')) {
          this.editorErrorMessage = this.inputErrorMessage || '输入的数据不合法!';
          this.$refs.input.classList.add('invalid');
          return false;
        }
        const { inputValidator } = this;
        if (typeof inputValidator === 'function') {
          const validateResult = inputValidator(this.inputValue);
          if (validateResult === false) {
            this.editorErrorMessage = this.inputErrorMessage || '输入的数据不合法!';
            this.$refs.input.classList.add('invalid');
            return false;
          }
          if (typeof validateResult === 'string') {
            this.editorErrorMessage = validateResult;
            return false;
          }
        }
      }
      this.editorErrorMessage = '';
      this.$refs.input.classList.remove('invalid');
      return true;
    },
    handleInputType(val) {
      if (val === 'range' || !this.$refs.input) return;
      this.$refs.input.type = val;
    },
    handleClickAgreement() {
      store.commit('SAVE_AGREE_SHOW', true)
      this.$sendLog({
        event_type: 'click',
        event_name: '用户协议',
        event_data: {
          name: '弹窗',
        },
      });
    },
    startPreciseCountdown() {
      if (!this.preciseCountDown && !this.savedPreciseCountDown) return;

      // 如果有保存的倒计时值，使用它来初始化
      if (this.savedPreciseCountDown && !this.preciseCountDown) {
        this.preciseCountDown = this.savedPreciseCountDown;
      }

      // 重置倒计时完成状态
      this.countdownFinished = false;

      // 计算初始时间
      const totalTime = this.preciseCountDown;
      this.minutes = Math.floor(totalTime / 60000);
      this.seconds = Math.floor((totalTime % 60000) / 1000);
      this.milliseconds = Math.floor((totalTime % 1000) / 10); // 取毫秒前两位，0-99

      // 计算结束时间
      const endTime = Date.now() + totalTime;

      // 清除之前的定时器
      if (this.countdownTimer) {
        clearInterval(this.countdownTimer);
      }

      // 设置10毫秒的定时器以保证毫秒的更新
      this.countdownTimer = setInterval(() => {
        const remaining = endTime - Date.now();
        if (remaining <= 0) {
          // 倒计时结束
          this.minutes = 0;
          this.seconds = 0;
          this.milliseconds = 0;
          this.countdownFinished = true; // 标记倒计时已完成
          clearInterval(this.countdownTimer);
          this.countdownTimer = null;
          return;
        }

        // 更新时间
        this.minutes = Math.floor(remaining / 60000);
        this.seconds = Math.floor((remaining % 60000) / 1000);
        this.milliseconds = Math.floor((remaining % 1000) / 10); // 0-99范围
      }, 10);
    },
    stopPreciseCountdown() {
      if (this.countdownTimer) {
        clearInterval(this.countdownTimer);
        this.countdownTimer = null;
      }
    },
    resetPreciseCountdown() {
      // 停止当前倒计时
      this.stopPreciseCountdown();

      // 如果有保存的倒计时值，使用它来重置
      if (this.savedPreciseCountDown) {
        this.preciseCountDown = this.savedPreciseCountDown;
        this.savedPreciseCountDown = null;
      }

      // 重置倒计时状态
      this.minutes = 0;
      this.seconds = 0;
      this.milliseconds = 0;
      this.countdownFinished = false;
    },
  },
  computed: {
    showCancelConfirmBtns() {
        return Object.keys(this.cancelConfirmBtnConfig).length
    },
    isPreciseCountdownBtn() {
        return !!this.preciseCountDown;
    },
    isOrder() {
      return this.message.includes('?isorder');
    },
    isTwoBg() {
      return this.message.includes('|');
    },
    newData() {
      return this.message.split('|');
    },
    styleClickbtn() {
      return {
        '--clickbtn-width': this.clickButtonConfig.width,
        '--clickbtn-top': this.clickButtonConfig.top,
      }
    },
    handEffectStyle() {
      return {
        '--handEffect-width': this.handEffectConfig.width,
        '--handEffect-top': this.handEffectConfig.top,
        '--hadnEffect-left': this.handEffectConfig.left,
      }
    },
    cancelConfirmBtnStyle() {
      return {
        '--btn-width': this.cancelConfirmBtnConfig.width,
        '--btn-height': this.cancelConfirmBtnConfig.height,
        '--btn-bottom': this.cancelConfirmBtnConfig.bottom,
        '--btn-marginRight': this.cancelConfirmBtnConfig.marginRight,
        '--btn-padding': this.preciseBtnConfig.padding || '0 5.33vw',
        '--btn-bottom-precise': this.preciseBtnConfig.bottom || '10vw',
      }
    },
    userAvatar() {
      return store.state.user_img || 'https://qncweb-back1.ktvsky.com/20221021/other/85220abb50ca0c8ff17e1b4045d563ff.png'
    },
    scrollMessagesStyle() {
      return {
        top: '-18vw',
        left: '50%',
        transform: 'translateX(-50%)',
        position: 'absolute'
      }
    },
  },
  watch: {
    inputValue() {
      if (this.$type === 'prompt') {
        this.validate();
      }
    },
    value(val) {
      this.handleInputType(this.inputType);
      if (val && this.$type === 'prompt') {
        setTimeout(() => {
          if (this.$refs.input) {
            this.$refs.input.focus();
          }
        }, 500);
      }

      // 当弹窗打开时，如果有preciseCountDown或savedPreciseCountDown，则重置并启动倒计时
      if (val && (this.preciseCountDown || this.savedPreciseCountDown)) {
        this.$nextTick(() => {
          this.resetPreciseCountdown();
          this.startPreciseCountdown();
        });
      }
    },
    inputType(val) {
      this.handleInputType(val);
    },
    preciseCountDown(newVal) {
      if (newVal) {
        this.$nextTick(() => {
          this.startPreciseCountdown();
        });
      } else {
        this.stopPreciseCountdown();
      }
    },
  },
  data() {
    return {
      title: '',
      message: '',
      value: '',
      type: '',
      showInput: false,
      inputValue: null,
      inputPlaceholder: '',
      inputPattern: null,
      inputValidator: null,
      inputErrorMessage: '',
      showConfirmButton: true,
      showCancelButton: false,
      confirmButtonText: CONFIRM_TEXT,
      cancelButtonText: CANCEL_TEXT,
      confirmButtonClass: '',
      confirmButtonDisabled: false,
      cancelButtonClass: '',
      editorErrorMessage: null,
      callback: null,
      imgLoaded: false,
      vipInfo: {},
      closeImg: require('../adsense/static/close.png'),
      goldMessage: {},
      showClose: true,
      restStyle: {},
      showInsideClose: false,
      countDownEndTime: 0,
      closeBtn: '',
      songItem: {},
      progressConfig: null,
      progressEndCallback: null,
      clickButtonConfig: '',
      handEffectConfig: '',
      closeCallback: null,
      cancelConfirmBtnConfig: {},
      isBottomClose: false,
      bottomCallback: null,
      showAgreement: false, // 是否显示用户协议
      showTopAgreement: false, // 是否显示上方用户协议
      showToastBottomAgreement: false, // 是否显示弹窗下用户协议
      isTopClose: false, // 是否显示顶部关闭按钮
      preciseCountDown: null,
      minutes: 0,
      seconds: 0,
      milliseconds: 0,
      countdownTimer: null,
      savedPreciseCountDown: null,
      showBreathBtns: false,
      countdownFinished: false, // 新增倒计时完成状态标记
      onlyBtnClose: false, // 新增：只能按钮关闭
      preciseBtnConfig: {},
      showTopAvatar: false,
      showCursor: false,
      tabConfig: null,
      showScrollMessages: false, // 是否显示滚动消息
      showTopText: '', // 新增：顶部文案
    };
  },
  created() {
    if (!store.state.intervalShowOrderList) {
      store.commit('SET_ORDER_LIST', false)
    }
  },
  beforeDestroy() {
    this.stopPreciseCountdown();
  },
};
</script>
<style lang="scss" scoped>
.msgbox-wrapper {
  z-index: $z_index_important;
  position: fixed;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  background: rgba(0, 0, 0, 0.7);
  display: flex;
  justify-content: center;
  align-items: center;
}
.msgbox {
  width: 590px;
  border-radius: 3px;
  font-size: 32px;
  -webkit-user-select: none;
  user-select: text;
  backface-visibility: hidden;
  transition: 0.2s;
  .msgbox-title {
    padding: 85px 0 0;
    .title {
      text-align: center;
      padding-left: 0;
      margin-bottom: 0;
      font-weight: bold;
      color: #333;
    }
  }
  .msgbox-content {
    .content {
      color: #999;
      margin: 0;
      text-align: center;
      line-height: 60px;
    }
  }
  .msgbox-btns {
    display: -webkit-box;
    display: -webkit-flex;
    display: -ms-flexbox;
    display: flex;
    line-height: 40px;
    margin-top: 20px;
    .msgbox-btn {
      width: 180px;
      height: 60px;
      margin: 0 auto;
      border-radius: 100px;
      line-height: 60px;
      text-align: center;
    }
    .msgbox-btn-cancel {
      color: #000;
      background: -webkit-gradient(
        linear,
        0 0,
        0 100%,
        from(#d8d4d0),
        to(#a7a3a1)
      );
    }
    .msgbox-btn-confirm {
      background: -webkit-gradient(
        linear,
        0 0,
        0 100%,
        from(#ff8c1a),
        to(#ff6d00)
      );
      color: #fff;
    }
  }
}
.delay-order-song {
  position: absolute;
  top: 420px;
  left: 50%;
  margin-left: -213px;
  h3 {
    width: 100%;
    @include txtOverflow();
    margin: 0 auto;
    text-align: center;
    font-size: 34px;
    color: #F0CF96;
    margin-bottom: 33px;
  }
}
.user-info {
  display: flex;
  align-items: center;
  justify-content: center;
  color: #fff;
  margin-bottom: 25px;
  .avatar {
    width: 52px;
    height: 52px;
    border-radius: 50%;
    margin-right: 20px;
    img {
      border-radius: 50%;
    }
  }
}
.fade-enter {
  opacity: 0;
  transform: translate3d(-50%, -50%, 0) scale(0.7);
}
.fade-leave-active {
  opacity: 0;
  transform: translate3d(-50%, -50%, 0) scale(0.9);
}
// 冠名样式
.title {
  font-size: 44px;
  padding-top: 0;
  // padding-top: px2rem(160);
  // font-size: px2rem(36);
  color: #5f320e;
  font-weight: 900;
}
.tips {
  position: absolute;
  bottom: 200px;
  left: 10vw;
  width: 80vw;
  height: 100px;
  line-height: 100px;
  background: rgba(0, 0, 0, 0.8);
  border-radius: 10px;
  color: #fff;
  font-size: 30px;
  text-align: center;
}

.ordersong {
  position: absolute;
  bottom: 23vw;
  left: 50%;
  transform: translateX(-50%);
  width: 380px;
  height: 80px;
  z-index: 11;
}
.gold-info {
  width: 100%;
  position: absolute;
  top: 260px;
  .avatar {
    margin: 0 auto 30px;
    width: 122px;
    height: 122px;
    border-radius: 50%;
    overflow: hidden;
  }
  p {
    color: #5D3010;
    text-align: center;
    font-size: 32px;
    font-weight: bold;
    span {
      color: #F34C01;
    }
  }
}
// plus会员开通成功弹窗 - 开始
.plus-toast {
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  .title-wrapper {
    width: fit-content;
    position: absolute;
    top: 96px;
    left: 50%;
    transform: translateX(-50%);
    font-size: 50px;
    color: #0a0701;
    text-align: center;
  }
  .price {
    position: absolute;
    left: 359px;
    bottom: 80px;
    color: #973904;
    font-size: 30px;
  }
}
.top-text {
  position: absolute;
  top: 310px;
  left: 0;
  width: 100%;
  text-align: center;
  font-size: 28px;
  color: #A01D00;
}
.down_time {
  position: absolute;
  bottom: 35px;
  left: 50%;
  font-family: PingFangSC, PingFangSC-Medium;
  transform: translate(-50%,0);
  font-weight: 500;
  text-align: center;
  color: #fe361f;
  opacity: 1;
  font-size: 28px;
}
.precise_countdown {
  position: absolute;
  bottom: 35px;
  left: 50%;
  font-family: PingFangSC, PingFangSC-Medium;
  transform: translate(-50%,0);
  font-weight: 500;
  text-align: center;
  color: #fe361f;
  opacity: 1;
  font-size: 28px;
}
.precise-countdown-wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
}
.precise-time-unit {
  display: inline-block;
  width: 40px;
  text-align: center;
  font-weight: bold;
}
.precise-time-separator {
  display: inline-block;
  text-align: center;
}
.precise-time-text {
  margin-left: 8px;
}
.precise-buttons {
  display: flex;
  justify-content: center;
  margin-top: 20px;
}
.precise-btn {
  width: 284px;
  height: 82px;
  object-fit: contain;
}
.precise-confirm-btn {
  margin-left: 20px;
}
.topBg {
  position: absolute;
  top: 0;
  left: 0;
}
// plus会员开通成功弹窗 - 结束
.clickButton {
  width: var(--clickbtn-width);
  position: absolute;
  top: var(--clickbtn-top);
  left: 50%;
  margin-left: calc(var(--clickbtn-width) / -2);
}
.handContainer {
  position: absolute;
  top: var(--handEffect-top);
  left: var(--hadnEffect-left);
  margin-left: calc(var(--handEffect-width) / -2);
  width: var(--handEffect-width);
  .handEffect {
    width: var(--handEffect-width);
  }
}

.breath {
  animation: breath 1s linear infinite;
}
.agreement {
  text-align: center;
  font-size: 24px;
  color: rgba(0, 0, 0, 0.4);
  padding: 20px 0;
  margin-top: -86px;
}
.top-close {
  width: 54px;
  position: absolute;
  right: 30px;
  top: 30px;
}
@keyframes breath {
  0% {
    transform: scale(0.95);
  }
  50% {
    transform: scale(1.05);
  }
  100% {
    transform: scale(0.95);
  }
}
.shake {
  animation: shakeX 2.5s linear 0s infinite normal;
  animation-fill-mode: both;
}
@keyframes shakeX {

  from,
  to {
    -webkit-transform: translate3d(0, 0, 0);
    transform: translate3d(0, 0, 0);
  }

  10%,
  30%,
  50%,
  70%,
  90% {
    -webkit-transform: translate3d(-10px, 0, 0);
    transform: translate3d(-10px, 0, 0);
  }

  20%,
  40%,
  60%,
  80% {
    -webkit-transform: translate3d(10px, 0, 0);
    transform: translate3d(10px, 0, 0);
  }
}
.btns-wrap {
    display: flex;
    position: absolute;
    bottom: var(--btn-bottom);
    left: 50%;
    transform: translateX(-50%);
    .btn {
      width: var(--btn-width);
      height: var(--btn-height);
        &:first-child {
          margin-right: var(--btn-marginRight);
        }
    }
}
.precise-btns-wrap {
  width: 100%;
  display: flex;
  justify-content: space-around;
  position: absolute;
  bottom: var(--btn-bottom-precise);
  left: 50%;
  transform: translateX(-50%);
  padding: var(--btn-padding);
  .btn {
    background-size: contain;
    background-repeat: no-repeat;
    position: relative;
    &:first-child {
      margin-right: 2.67vw;
    }
  }
  .cursor {
    position: absolute;
    top: 2.67vw;
    right: 6.67vw;
    width: 15.47vw;
    height: 15.47vw;
  }
  .custom-tab {
    position: absolute;
    padding: 0.53vw 1.6vw;
    font-size: 3.2vw;
    white-space: nowrap;
    z-index: 1;
  }
}
.close-icon {
   position: absolute;
   right: 2vw;
   top: 2vw;
   width: 7vw;
   height: 7vw;
}
.bottom-close {
   position: absolute;
   left: 256px;
   bottom: -20vw;
   width: 78px;
   height: 78px;
}
.back-home {
  position: absolute;
  left: 0;
  bottom: 0;
  width: 590px;
  height: 80px;
}
.agreement-top {
  position: absolute;
  top: -20px;
  left: 0;
  width: 100%;
  font-size: 24px;
  color: #999999;
  text-align: center;
}
.agreement-bottom {
  position: absolute;
  bottom: -80px;
  left: 0;
  width: 100%;
  font-size: 24px;
  color: #999999;
  text-align: center;
}
</style>
